import { ReactComponent as LirariLandingPageDesktopLogo } from './../../assets/images/lirari-landing-page-desktop-logo.svg'
import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { ReactComponent as LookingForMusicians } from './../../assets/images/lfm.svg'
import { ReactComponent as Musicians } from './../../assets/images/musicians.svg'
import { useNavigate } from 'react-router-dom'

const LandingPage = () => {
  const navigate = useNavigate()

  return (
    <div className="bg-white flex flex-col lg:flex-row h-full min-w-full">
      <>
        {/* Desktop */}
        <div className="hidden lg:flex flex-col h-full w-1/3 pt-20 items-end z-10">
          <Musicians className="min-h-[50rem] h-[50rem]"></Musicians>
        </div>
        <div className="hidden lg:flex flex-col w-1/3 items-center">
          <div className="text-6xl pt-10">Lirari</div>
          <div className="text-3xl pt-5">The Professional</div>
          <div className="text-3xl">{`Musicians'`} Network</div>
          <LirariLandingPageDesktopLogo className="min-h-[40rem] h-[42%]" />
          <button
            className="flex flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] tracking-[0.1em] text-black justify-center items-center mt-[-17%]"
            onClick={() => navigate('/login')}
          >
            <div>SIGN UP</div>
            <div>FREE</div>
          </button>
        </div>
        <div className="hidden lg:flex flex-col h-full w-1/3 pt-20 items-start z-10">
          <LookingForMusicians className="min-h-[50rem] h-[50rem] pt-[1.5rem]"></LookingForMusicians>
        </div>
      </>
      <>
        {/* Mobile */}
        <div className="flex lg:hidden flex-row justify-center">
          <div className="flex flex-col text-center items-center">
            <div className="text-6xl pt-10">Lirari</div>
            <div className="text-3xl pt-5">The Professional</div>
            <div className="text-3xl">{`Musicians'`} Network</div>
          </div>
        </div>
        <div className="flex lg:hidden flex-col h-full w-full items-center pt-10">
          <Musicians className="min-h-[50rem] h-[50rem]" />
        </div>
        <div className="flex lg:hidden flex-row justify-center pt-20">
          <div className="flex flex-col text-center items-center">
            <LirariLandingPageMobileLogo />
          </div>
        </div>
        <div className="flex lg:hidden flex-col h-full w-full items-center pt-20">
          <LookingForMusicians className="min-h-[50rem] h-[50rem] pt-[1.5rem]" />
        </div>
        <div className="flex lg:hidden flex-row justify-center">
          <button
            className="flex flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] tracking-[0.1em] text-black justify-center items-center mt-10 mb-20"
            onClick={() => navigate('/login')}
          >
            <div>SIGN UP</div>
            <div>FREE</div>
          </button>
        </div>
      </>
    </div>
  )
}

export default LandingPage
